import LayoutSkeleton from "@/components/LayoutSkeleton";
import { useAuth } from "@/contexts/AuthContext";
import type { ProtectedRouteProps } from "@/types/auth";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }: ProtectedRouteProps) => {
  const { user, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <LayoutSkeleton />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!user.hasSetupComplete && location.pathname !== "/setup") {
    return <Navigate to="/setup" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
